import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './language/en.json'
import ua from './language/ua.json'
import ru from './language/ru.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ua: { translation: ua },
      ru: { translation: ru },
    },
    lng: localStorage.getItem('languageCode') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n